import LiveBuncherPerformance from "./pages/live/LiveBuncherPerformance";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import Layout from "./layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// ================= PAGES =================
import LoginPage from "./pages/auth/LoginPage";
import CapturePage from "./pages/capture/CapturePage";
import SessionPage from "./pages/capture/SessionPage";
import ManagePage from "./pages/manage/ManagePage";
import UserManagementPage from "./pages/manage/UserManagementPage";
import HarvestQR from "./pages/capture/HarvestQR";
import IntakeQC from "./pages/quality/IntakeQC";
import RejectionsPage from "./pages/quality/RejectionsPage";
import AnalyticsHub from "./pages/analytics/AnalyticsHub";
import ClientPortalPage from "./pages/clients/ClientPortalPage";
import ClientPasswordPage from "./pages/clients/ClientPasswordPage";
import PasswordResetPage from "./pages/clients/PasswordResetPage";

// ================= ANALYTICS MODULES =================
import PackhouseDashboard from "./AnalyticsHubHooks/PackhouseDashboard";
import RejectionsAnalytics from "./AnalyticsHubHooks/Rejectionsanalytics";
import FieldProductionDashboard from "./AnalyticsHubHooks/FieldProductionDashboard";
import IntakeQCDashboard from "./AnalyticsHubHooks/IntakeQCDashboard";
import GradeOutSummary from "./pages/analytics/GradeOutSummary";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>

          {/* ================= LOGIN ================= */}
          <Route path="/live/bunchers" element={<LiveBuncherPerformance />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password-reset" element={<PasswordResetPage />} />

          {/* ================= APP LAYOUT WRAPPER ================= */}
          <Route element={<Layout />}>
            <Route path="/harvest-rights" element={<Navigate to="/users?tab=access" replace />} />

            {/* ================= MAIN HUB ================= */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute feature="dashboard">
                  <AnalyticsHub />
                </ProtectedRoute>
              }
            />

            {/* ALSO ALLOW /analytics TO MAP TO HUB */}
            <Route
              path="/analytics"
              element={
                <ProtectedRoute feature="dashboard">
                  <AnalyticsHub />
                </ProtectedRoute>
              }
            />

            {/* ================= ANALYTICS MODULES ================= */}

            {/* Intake QC Dashboard */}
            <Route
              path="/analytics/intake"
              element={
                <ProtectedRoute feature="intake_analytics">
                  <IntakeQCDashboard />
                </ProtectedRoute>
              }
            />

            {/* Packhouse */}
            <Route
              path="/analytics/main"
              element={
                <ProtectedRoute feature="analytics">
                  <PackhouseDashboard />
                </ProtectedRoute>
              }
            />

            {/* Field Production */}
            <Route
              path="/analytics/grade-out"
              element={
                <ProtectedRoute feature="analytics">
                  <GradeOutSummary />
                </ProtectedRoute>
              }
            />

            {/* Field Production */}
            <Route
              path="/analytics/bunchers"
              element={
                <ProtectedRoute feature="buncher_performance">
                  <FieldProductionDashboard />
                </ProtectedRoute>
              }
            />

            {/* Rejections Analytics */}
            <Route
              path="/analytics/rejections"
              element={
                <ProtectedRoute feature="rejections_analytics">
                  <RejectionsAnalytics />
                </ProtectedRoute>
              }
            />

            {/* ================= OPERATION MODULES ================= */}

            <Route
              path="/capture"
              element={
                <ProtectedRoute feature="capture">
                  <CapturePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/harvest-data-capture"
              element={
                <ProtectedRoute feature="harvest_data_capture"><HarvestQR /></ProtectedRoute>
              }
            />

            <Route
              path="/intake-qc"
              element={
                <ProtectedRoute feature="intake_qc">
                  <IntakeQC />
                </ProtectedRoute>
              }
            />

            <Route
              path="/session"
              element={
                <ProtectedRoute feature="session">
                  <SessionPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/manage"
              element={
                <ProtectedRoute feature="manage">
                  <ManagePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute feature="users">
                  <UserManagementPage />
                </ProtectedRoute>
              }
            />

            <Route path="/clients/password" element={<ProtectedRoute feature="client_portal"><ClientPasswordPage /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute feature="client_portal"><ClientPortalPage /></ProtectedRoute>} />

            <Route
              path="/rejections"
              element={
                <ProtectedRoute feature="rejections">
                  <RejectionsPage />
                </ProtectedRoute>
              }
            />

          </Route>

          {/* ================= DEFAULT ROUTES ================= */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
